<template>
  <v-container>
    <v-card
      class="mx-auto"
      max-width="500"
    >
      <v-card-title>
        {{
          loading ? $t("Processing your credits...") :
          (errorMessage ? $t("Error") : $t("Thank you for your purchase!"))
        }}
      </v-card-title>
      <v-card-text>
        <template v-if="!loading">
          <p v-if="!errorMessage">{{ $t("Your credits have been added successfully.") }}</p>
          <p
            v-else
            class="error-text"
          >
            {{ errorMessage }}
          </p>
        </template>
        <v-progress-circular
          v-if="loading"
          indeterminate
          color="primary"
          class="my-4"
        ></v-progress-circular>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'StripeSuccess',
  data() {
    return {
      sessionId: this.$route.query.session_id,
      selectedCredits: 0,
      loading: true,
      token: this.$route.query.hash,
      errorMessage: '', // To store any error message
    };
  },
  mounted() {
    if (this.sessionId) {
      this.processPayment(this.sessionId);
    }
  },
  methods: {
    async processPayment(sessionId) {
      try {
        const response = await axios.post(`${process.env.VUE_APP_API_URL}/stripe/process-payment`, {
          sessionId,
        },
        {
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        });

        this.selectedCredits = response.data.amount_total / 100;

        if (response.data.redirectUrl) {
          setTimeout(() => {
            this.loading = false;
            window.location.href = response.data.redirectUrl;
          }, 2000);
        }
      } catch (error) {
        // Capture and display the error message from the response or fallback
        console.error('Error processing payment:', error);
        this.errorMessage = error.response?.data?.error || this.$t('An unexpected error occurred while processing your payment.');
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.error-text {
  color: red;
  font-weight: bold;
}
</style>
